import { map, reject } from "lodash/fp";

import { post } from "@readai/common/api";
import {
  ListCitationsRequest,
  ListCitationsResponse,
  ListEntitiesRequest,
  ListEntitiesResponse,
  ListProviderThreadsRequest,
  ListProviderThreadsResponse,
  ListProviderThreadSummariesRequest,
  ListProviderThreadSummariesResponse,
  ListProviderThreadTopicsRequest,
  ListProviderThreadTopicsResponse,
  Topic,
} from "@readai/common/types";

export const listEntities = async (
  request: ListEntitiesRequest,
): Promise<ListEntitiesResponse> => {
  return post("/entities:list", request, { withCreds: true });
};

export const listProviderThreadTopics = async (
  request: ListProviderThreadTopicsRequest,
): Promise<ListProviderThreadTopicsResponse> => {
  const data = (await post("/v1/provider-thread-topics/list", request, {
    withCreds: true,
  })) as ListProviderThreadTopicsResponse;

  // ENG-13314 Filter out multi_source_external_domain topics
  return {
    ...data,
    objects: map(
      (obj) => ({
        ...obj,
        topics: reject<Topic>(
          (topic) => topic.kind === "multi_source_external_domain",
          obj.topics,
        ),
      }),
      data.objects,
    ),
  };
};

export const listCitations = async (
  request: ListCitationsRequest,
): Promise<ListCitationsResponse> => {
  return (await post("/v1/citations:list", request, {
    withCreds: true,
  })) as ListCitationsResponse;
};

export const listProviderThreadSummaries = async (
  request: ListProviderThreadSummariesRequest,
): Promise<ListProviderThreadSummariesResponse> => {
  return (await post("/v1/provider-thread-summaries/list", request, {
    withCreds: true,
  })) as ListProviderThreadSummariesResponse;
};

export const listProviderThreads = async (
  request: ListProviderThreadsRequest,
): Promise<ListProviderThreadsResponse> => {
  return (await post("/draft-emails/provider-threads/list", request, {
    withCreds: true,
  })) as ListProviderThreadsResponse;
};

export const listEntitiesV1 = async (
  request: ListEntitiesRequest,
): Promise<ListEntitiesResponse> => {
  return (await post("/v1/entities/list", request, {
    withCreds: true,
  })) as ListEntitiesResponse;
};
